import React from 'react';
import Link from '../Link';
import { IconButton } from 'react-toolbox/lib/button';
import Button from '../Button';

const ButtonLink = ({
  to,
  iconOnly = false,
  onClick,
  children,
  className,
  style: {
    button: buttonStyle = {},
    anchor: linkStyle = {},
    ...restStyle
  } = {},
  ...rest
}) => {
  const ButtonComponent = iconOnly ? IconButton : Button;
  return (
    <Link
      to={to}
      onClick={onClick}
      className={className}
      style={{ textDecoration: 'none', ...linkStyle }}
    >
      <ButtonComponent style={{ ...buttonStyle, ...restStyle }} {...rest}>
        {children}
      </ButtonComponent>
    </Link>
  );
};

export default ButtonLink;



// WEBPACK FOOTER //
// ./src/common/components/ButtonLink/index.js